module.exports = __webpack_public_path__ + "img/main-map.9b77c967.jpg";